import { render, staticRenderFns } from "./OptionSlideshow.vue?vue&type=template&id=31388ad4&scoped=true&"
import script from "./OptionSlideshow.vue?vue&type=script&lang=js&"
export * from "./OptionSlideshow.vue?vue&type=script&lang=js&"
import style0 from "./OptionSlideshow.vue?vue&type=style&index=0&id=31388ad4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31388ad4",
  null
  
)

export default component.exports